import {Tooltip, TooltipContent, TooltipTrigger} from "@/components/ui/tooltip";
import {formatResidentRedactedField, RESIDENT_REDACTED_TOOLTIP} from "@/src/modules/core/lib/resident-redacted-field";
import type {ResidentMembership} from "@/src/modules/core/types/resident-membership";
import {cn} from "@/lib/utils";

type ResidentRedactedLabelProps = {
  value: string | null | undefined;
  membership: ResidentMembership | null | undefined;
  className?: string;
  fallback?: string;
};

export function ResidentRedactedLabel({
  value,
  membership,
  className,
  fallback,
}: ResidentRedactedLabelProps) {
  const {text, isRedacted} = formatResidentRedactedField(value, membership, fallback);

  if (!isRedacted) {
    return <span className={className}>{text}</span>;
  }

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span className={cn("text-muted-foreground italic", className)}>{text}</span>
        }
      />
      <TooltipContent side="top" className="max-w-xs">
        {RESIDENT_REDACTED_TOOLTIP}
      </TooltipContent>
    </Tooltip>
  );
}
